import React from 'react';
import { NavigationContext } from '../contexts';
import useDrawer from './utils/use-drawer';

var NavigationProvider = function NavigationProvider(_ref) {
  var children = _ref.children;
  var drawer = useDrawer();
  var value = {
    drawer: drawer
  };
  return /*#__PURE__*/React.createElement(NavigationContext.Provider, {
    value: value
  }, children);
};

export default NavigationProvider;